import React from "react";

import { CONSULTATION, CONTACT_DETAILS } from "../../data/content";
import { WhatsAppIcon } from "./Icons";

//"We look forward to exceeding your expectations ..." with the WhatsApp button (Home & Contact)
const Consultation = () => {
  return (
    <section className={"consultation"}>
      <p className={"body-text"}>{CONSULTATION.TEXT}</p>
      <a
        href={CONTACT_DETAILS.WHATSAPP_LINK}
        className={"btn is-wide"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        <WhatsAppIcon />
        {CONSULTATION.BUTTON}
      </a>
    </section>
  );
};

export default Consultation;
